import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../share/services/api.service';
import {
  AngularSlickgridModule,
  Column,
  Filters,
  Formatters,
  GridOption,
  MultipleSelectOption,
} from 'angular-slickgrid';
import { FieldType } from 'angular-slickgrid';
import { TextExportService } from '@slickgrid-universal/text-export';
import { Logclass } from '../../share/models/logclass.model';
import { LogLogging } from '../../share/models/log-logging-model';
import { SharedModule } from '../../share/shared.module';
import { SessionService } from '../../share/services/session.service';

@Component({
  selector: 'app-logger',
  templateUrl: './logger.component.html',
  styleUrls: ['./logger.component.css'],
  imports: [SharedModule, AngularSlickgridModule],
})
export class LoggerComponent implements OnInit {
  // account;
  memberId: string = '';
  columnDefinitions: Column[] = [];
  gridOptions: GridOption = {};
  dataset: any[] = [];
  temp: any[] = [];
  LogMessages: string[] = [];
  EventTypes: string[] = [];
  MemberList: string[] = [];
  GroupList: string[] = [];
  isLoaded: boolean = false;
  numberofrows: number = 100;

  constructor(
    private api: ApiService,
    private sessionService: SessionService,
  ) {}

  ngOnInit(): void {
    // Helper
    const StringIsAlphanumerical = (value: string) =>
      isNaN(Number(value)) === true;

    this.gridOptions = {
      enableGridMenu: true,
      enableSorting: true,
      enableFiltering: true,
      enableHeaderButton: true,
      enableHeaderMenu: true,
      forceFitColumns: true,
      autoResize: {
        container: '#grid-container', // container DOM selector
      },
      enableAutoResize: true,
      enablePagination: true,
      rowHeight: 42,
      pagination: {
        pageSizes: [5, 10, 15, 20, 25, 50, 75, this.numberofrows],
        pageSize: 15,
      },
      // enableTextExport is what actually makes the Grid Menu add the "Export to CSV" /
      // "Export to Tab-Delimited" commands - without it, the item never shows up even if
      // TextExportService is registered and hideExportCsvCommand is false.
      enableTextExport: true,
      textExportOptions: {
        exportWithFormatter: true,
      },
      // Export to CSV/Text is an opt-in feature in Slickgrid-Universal: the service must be
      // registered here or the "Export to CSV" command won't actually do anything.
      externalResources: [new TextExportService()],
      gridMenu: {
        hideExportCsvCommand: false,
        hideExportTextDelimitedCommand: false,
        hideExportExcelCommand: false,
        hideClearAllSortingCommand: false,
        hideForceFitButton: false,
        onBeforeMenuShow: (a, b) => {},
      },
    };

    this.api.getLogs().subscribe({
      next: (data: LogLogging[]) => {
        console.log('Found ' + data.length + ' Log Records.');
        console.log(data);

        if (this.sessionService.getMaingroupName() != 'FetrapiAdmin') {
          data = data.filter(
            (x) => x.actorId == this.sessionService.getGroupGId(),
          );
        }

        var entryNumber = 1;
        data.forEach((logEntry) => {
          const newContent = <Logclass>(<unknown>{
            id: entryNumber,
            DateTimeCreated: new Date(logEntry.dateTimeCreated),
            LogentryType: logEntry.logEntryType,
            MemberId: logEntry.actorId,
            MemberName: logEntry.memberName,
            MemberGroup: logEntry.memberOf,
            DatasetId: logEntry.datasetId,
            LogMessage: logEntry.logMessage,
          });
          entryNumber++;
          //Push the new row
          this.temp.push(newContent);
        });
        // fill the dataset with your data
        this.numberofrows = entryNumber;
        this.gridOptions.pagination = {
          pageSize: 15,
          pageSizes: [5, 10, 15, 20, 25, 50, 75, this.numberofrows - 1],
        };
        this.dataset = this.temp;
        this.LogMessages = [
          ...new Set(data.map((item) => item.logMessage)),
        ].sort();
        this.EventTypes = [
          ...new Set(data.map((item) => item.logEntryType)),
        ].sort();
        this.MemberList = [
          ...new Set(data.map((item) => item.memberName)),
        ].sort();
        this.GroupList = [...new Set(data.map((item) => item.memberOf))].sort();

        if (this.sessionService.getMaingroupName() != 'FetrapiAdmin') {
          // TODO as unknown as MultipleSelectOption lijkt een gekke oplossing
          this.columnDefinitions = [
            {
              id: 'DateTimeCreated',
              name: 'Date & Time',
              field: 'DateTimeCreated',
              filterable: true,
              sortable: true,
              formatter: Formatters['dateTimeEuro'],
              type: FieldType.dateTimeEuro,
              outputType: FieldType.dateTimeEuro,
              filter: { model: Filters['dateRange'] },
            },
            {
              id: 'LogentryType',
              name: 'Event Type',
              field: 'LogentryType',
              sortable: true,
              filterable: true,
              type: FieldType.string,
              filter: {
                collection: Object.values(this.EventTypes)
                  .filter(StringIsAlphanumerical)
                  .map((k) => ({ value: `${k}`, label: `${k}` })),
                model: Filters['multipleSelect'],
                filterOptions: {
                  offsetLeft: 14,
                } as unknown as MultipleSelectOption,
                placeholder: 'Filter on log type',
              },
            },
            {
              id: 'id',
              name: 'Dataset ID',
              field: 'DatasetId',
              sortable: true,
              filterable: true,
              type: FieldType.string,
            },
            {
              id: 'LogMessage',
              name: 'LogMessage',
              field: 'LogMessage',
              sortable: true,
              filterable: true,
              type: FieldType.string,
              filter: {
                collection: Object.values(this.LogMessages)
                  .filter(StringIsAlphanumerical)
                  .map((k) => ({ value: `${k}`, label: `${k}` })),
                model: Filters['multipleSelect'],
                filterOptions: {
                  offsetLeft: 14,
                } as unknown as MultipleSelectOption,
                placeholder: 'Filter on Message',
              },
            },
          ];
        } else {
          //Admin
          // TODO as unknown as MultipleSelectOption lijkt een gekke oplossing
          this.columnDefinitions = [
            {
              id: 'MemberName',
              name: 'MemberName',
              field: 'MemberName',
              filterable: true,
              sortable: true,
              type: FieldType.string,
              filter: {
                collection: Object.values(this.MemberList).map((k) => ({
                  value: `${k}`,
                  label: `${k}`,
                })),
                model: Filters['multipleSelect'],
                filterOptions: {
                  offsetLeft: 14,
                } as unknown as MultipleSelectOption,
                placeholder: 'Filter on Member Name',
              },
            },
            {
              id: 'MemberGroup',
              name: 'Group',
              field: 'MemberGroup',
              filterable: true,
              sortable: true,
              type: FieldType.string,
              filter: {
                collection: Object.values(this.GroupList).map((k) => ({
                  value: `${k}`,
                  label: `${k}`,
                })),
                model: Filters['multipleSelect'],
                filterOptions: {
                  offsetLeft: 14,
                } as unknown as MultipleSelectOption,
                placeholder: 'Filter on Member Group',
              },
            },
            {
              id: 'DateTimeCreated',
              name: 'Date & Time',
              field: 'DateTimeCreated',
              filterable: true,
              sortable: true,
              formatter: Formatters['dateTimeEuro'],
              type: FieldType.dateTimeEuro,
              outputType: FieldType.dateTimeEuro,
              filter: { model: Filters['dateRange'] },
            },
            {
              id: 'LogentryType',
              name: 'Event Type',
              field: 'LogentryType',
              sortable: true,
              filterable: true,
              type: FieldType.string,
              filter: {
                collection: Object.values(this.EventTypes).map((k) => ({
                  value: `${k}`,
                  label: `${k}`,
                })),
                model: Filters['multipleSelect'],
                filterOptions: {
                  offsetLeft: 14,
                } as unknown as MultipleSelectOption,
                placeholder: 'Filter on log type',
              },
            },
            {
              id: 'id',
              name: 'Dataset ID',
              field: 'DatasetId',
              sortable: true,
              filterable: true,
              type: FieldType.string,
            },
            {
              id: 'LogMessage',
              name: 'LogMessage',
              field: 'LogMessage',
              sortable: true,
              filterable: true,
              type: FieldType.string,
              filter: {
                collection: Object.values(this.LogMessages).map((k) => ({
                  value: `${k}`,
                  label: `${k}`,
                })),
                model: Filters['multipleSelect'],
                filterOptions: {
                  offsetLeft: 14,
                } as unknown as MultipleSelectOption,
                placeholder: 'Filter on Message',
              },
            },
          ];
        }

        this.isLoaded = true;
      },
      error: (error: any) => {
        this.api.errorhandler(error);
      },
    });
  }
}
